export default __webpack_public_path__ + "static/media/core2-v2.e7b252dc.png";